import { NgModule } from "@angular/core"
import { DeclinePostForm } from "./decline-post-form.component"
import { PostReviewForm } from "./post-review-form.component"
import { PostWlReviewForm } from './post-wl-review-form.component'
import { PurchasePostForm } from "./purchase-post-form.component"
import { MultipassPurchasePostForm } from "./multipass-purchase-post-form.component"
import { TakeBackPostForm } from "./take-back-post-form.component"
import { WhiteLabelForm } from "./white-label-form.component"
import { CommonModule } from "@angular/common"
import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import { AccordionModule } from "ngx-bootstrap/accordion"
import { ModalModule } from "src/modules/modal/modal.module"
import { RatePostModal } from "../modals/rate-post-modal.component"
import { RouterModule } from "@angular/router"
import { RatingStarsModule } from 'src/modules/rating-stars/rating-stars.module'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { MatSlideToggleModule } from "@angular/material/slide-toggle"


const exportedComponents = [
  DeclinePostForm,
  PostReviewForm,
  PostWlReviewForm,
  PurchasePostForm,
  TakeBackPostForm,
  WhiteLabelForm,
  MultipassPurchasePostForm,
]

@NgModule({
  declarations: [
    ...exportedComponents,
    RatePostModal,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AccordionModule,
    ModalModule,
    RouterModule,
    RatingStarsModule,
    BsDropdownModule,
    MatSlideToggleModule,
  ],
  exports: exportedComponents
})
export class PostBoxFormsModule { }
